import { render, staticRenderFns } from "./ProvinceSelect.vue?vue&type=template&id=6f486988&scoped=true"
import script from "./ProvinceSelect.vue?vue&type=script&lang=js"
export * from "./ProvinceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f486988",
  null
  
)

export default component.exports